/**
 * Created by wuhuping on 2017/5/16.
 */
import validator from './validator'
import md5Tool from 'src/tools/md5Tool'
export default {
  signForUrlOrFormData(datas, isUrl, loginSessionID) {
    if (validator.checkEmpty(loginSessionID)) {
      return datas;
    }
    let params = {};
    if (datas === null || datas === '') {
      params.xyebankSign = md5Tool.md5(loginSessionID);
      return params;
    }
    let keySort = [];
    params = datas;
    if (params) {
      for (let key in params) {
        keySort[keySort.length] = key;
      }
    }
    if (isUrl) {
      keySort.sort();
    }
    // 普通参数的值（非空、非空字符串、非数组）
    let ordinaryParamVal = '';
    for (let index in keySort) {
      for (let param in params) {
        if (param === keySort[index] && params[param] !== null && !Array.isArray(params[param])) {
          if (params[param] instanceof String) {
            if (params[param].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
              ordinaryParamVal += params[param];
            }
          } else {
            ordinaryParamVal += params[param];
          }
        }
      }
    }
    if (!validator.checkEmpty(loginSessionID)) {
      ordinaryParamVal = md5Tool.md5(ordinaryParamVal + loginSessionID);
    }
    params.xyebankSign = ordinaryParamVal;
    return params;
  }
}



// WEBPACK FOOTER //
// ./src/tools/httpSign.js